//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Video',
  props: {
    id: {
      type: Number,
      default: null
    },
    widthVideo: {
      type: Number,
      default: 40
    },
    fileName: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  }
}
